module.exports = __webpack_public_path__ + "static/media/kick.de62a038.wav";